import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../requests";
import { BasicContext } from "../App";
import UserProfileData from "../components/user/UserProfileData";
import UserChangePassword from "../components/user/UserChangePassword";
import UserChangeEmail from "../components/user/UserChangeEmail";
import UserAgreements from "../components/user/UserAgreements";
import ConfirmModal from "../components/modals/ConfirmModal";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, setAlerts, logout } = useContext(BasicContext);
    const [user, setUser] = useState(null);
    const [showDeactivateAccountModal, setShowDeactivateAccountModal] = useState(false);
    const navigate = useNavigate();

    const getUserData = async () => {
        const res = await postMethod("/get-user-data");
        if (checkServerData(res)) {
            setUser(res.data.user);
        }
    };

    const deactivateAccount = async () => {
        const res = await postMethod("/deactivate-profile");
        if (checkServerData(res)) {
            logout("user profile logout");
            navigate("/app");
            setAlerts([{ variant: "success", message: t("success.accountDeleted") }]);
        }
    };

    useEffect(() => {
        if (user) setLoading(false);
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        getUserData();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Container className="pt-5 pm-4">
                {loading ? (
                    <Row>
                        <Col xs={12} className="text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <UserProfileData data={user} />
                        <UserChangePassword />
                        <UserChangeEmail email={user.user_email} />
                        <UserAgreements data={user} />
                        <Col xs={12} className="px-4 px-lg-2">
                            <p className="h5 mt-4 mb-3">{t("users.deleteAccount")}</p>
                            <Button variant="outline-secondary" className="mb-5" onClick={() => setShowDeactivateAccountModal(true)}>
                                {t("delete")}
                            </Button>
                        </Col>
                    </Row>
                )}
            </Container>

            {showDeactivateAccountModal && (
                <ConfirmModal
                    show={true}
                    onClose={() => setShowDeactivateAccountModal(false)}
                    text={t("deleteAccountModal.text")}
                    proceedTxt={t("deleteAccountModal.proceedTxt")}
                    cancelTxt={t("deleteAccountModal.cancelTxt")}
                    onProceed={() => {
                        setAlerts([{ variant: "info", message: t("info.deletingAccount") }]);
                        deactivateAccount();
                    }}
                    title={t("users.deleteAccount")}
                />
            )}
        </Fragment>
    );
};

export default UserProfile;
